import { createContext } from 'react';

export interface PageTitleContextType {
  title: string;
  setPageTitle: (title: string) => void;
}

export const PageTitleContext = createContext<PageTitleContextType>({
  title: '',
  setPageTitle: () => {},
});
